'use client';

import { useState } from 'react';
import Header from '@/components/common/Header';
import ConsultationModal from '@/components/common/ConsultationModal';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import SolutionSection from './SolutionSection';
import ServicesSection from './ServicesSection';
import IndustriesSection from './IndustriesSection';

import FAQSection from './FAQSection';
import FooterSection from './FooterSection';

const LandingPageInteractive = () => {
  const [isConsultationModalOpen, setIsConsultationModalOpen] = useState(false);
  const [isScopeModalOpen, setIsScopeModalOpen] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  const handleBookConsultation = () => {
    setIsConsultationModalOpen(true);
  };

  const handleCloseConsultation = () => {
    setIsConsultationModalOpen(false);
  };

  const handleScopeModalChange = (isOpen: boolean) => {
    setIsScopeModalOpen(isOpen);
  };

  const handleBookingModalChange = (isOpen: boolean) => {
    setIsBookingModalOpen(isOpen);
  };

  const handleIndustryClick = (industryId: string) => {
    // Scroll to industries section to ensure context
    const industriesSection = document.getElementById('industries');
    if (industriesSection) {
      industriesSection.scrollIntoView({ behavior: 'smooth' });
      // Trigger modal after scroll with slight delay
      setTimeout(() => {
        const event = new CustomEvent('openIndustryModal', { detail: industryId });
        window.dispatchEvent(event);
      }, 500);
    }
  };

  const handleServiceClick = (serviceId: string) => {
    // Scroll to services section to ensure context
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
      // Trigger modal after scroll with slight delay
      setTimeout(() => {
        const event = new CustomEvent('openServiceModal', { detail: serviceId });
        window.dispatchEvent(event);
      }, 500);
    }
  };

  return (
    <>
      <Header data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:64:6" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="64" data-component-end-line="64" data-component-file="LandingPageInteractive.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" isHidden={isScopeModalOpen || isBookingModalOpen} />
      <main data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:65:6" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="65" data-component-end-line="80" data-component-file="LandingPageInteractive.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22pt-20%22%7D" className="pt-20">
        <HeroSection data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:66:8" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="66" data-component-end-line="66" data-component-file="LandingPageInteractive.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D" onBookConsultation={handleBookConsultation} onBookingModalChange={handleBookingModalChange} />
        <ProblemSection data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:67:8" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="67" data-component-end-line="67" data-component-file="LandingPageInteractive.tsx" data-component-name="ProblemSection" data-component-content="%7B%22elementName%22%3A%22ProblemSection%22%7D" />
        <SolutionSection data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:68:8" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="68" data-component-end-line="68" data-component-file="LandingPageInteractive.tsx" data-component-name="SolutionSection" data-component-content="%7B%22elementName%22%3A%22SolutionSection%22%7D" />
        <ServicesSection data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:69:8" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="69" data-component-end-line="72" data-component-file="LandingPageInteractive.tsx" data-component-name="ServicesSection" data-component-content="%7B%22elementName%22%3A%22ServicesSection%22%7D" 
          onBookConsultation={handleBookConsultation}
          onScopeModalChange={handleScopeModalChange}
        />
        <IndustriesSection data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:73:8" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="73" data-component-end-line="73" data-component-file="LandingPageInteractive.tsx" data-component-name="IndustriesSection" data-component-content="%7B%22elementName%22%3A%22IndustriesSection%22%7D" onScopeModalChange={handleScopeModalChange} />
        <FAQSection data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:74:8" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="74" data-component-end-line="74" data-component-file="LandingPageInteractive.tsx" data-component-name="FAQSection" data-component-content="%7B%22elementName%22%3A%22FAQSection%22%7D" />
        <FooterSection data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:75:8" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="75" data-component-end-line="79" data-component-file="LandingPageInteractive.tsx" data-component-name="FooterSection" data-component-content="%7B%22elementName%22%3A%22FooterSection%22%7D" 
          onIndustryClick={handleIndustryClick}
          onServiceClick={handleServiceClick}
          hideDataLittSection={isBookingModalOpen}
        />
      </main>
      <ConsultationModal data-component-id="src/app/landing-page/components/LandingPageInteractive.tsx:81:6" data-component-path="src/app/landing-page/components/LandingPageInteractive.tsx" data-component-line="81" data-component-end-line="84" data-component-file="LandingPageInteractive.tsx" data-component-name="ConsultationModal" data-component-content="%7B%22elementName%22%3A%22ConsultationModal%22%7D"
        isOpen={isConsultationModalOpen}
        onClose={handleCloseConsultation}
      />
    </>
  );
};

export default LandingPageInteractive;